import { Record } from 'immutable';

export const TeamResumeStats = new Record({
  isPending: false,
  error: null,
  team_id: null,
  count_members: 0,
  count_mp: 0,
  count_tt: 0,
  progress_mp: 0,
  progress_tt: 0,
});